import { Component, Input } from "@angular/core";
import { NavController } from "ionic-angular";
import * as moment from "moment";
import { Observable, Subscription } from "rxjs";

import { Settings } from "../../providers";
import { WeatherProvider } from "../../providers/weather/weather";
import { WEATHER_ICONS } from "../../providers/weather/weather.enum";

import { NodeService } from "../../providers/api/node.service";

@Component({
  selector: "main-header",
  templateUrl: "main-header.html",
})
export class MainHeaderComponent {
  public dateDay: any;
  public dateMonth: any;
  public dateTime: any;
  public dateDayName: any;
  public tempDegrees: any = "";
  public tempIcon: any;

  public WEATHER_ICONS: any = WEATHER_ICONS;

  private clock$: Subscription;
  private weather$: Subscription;
  private noDisturb$: Subscription;
  private panic$: Subscription;
  private block$: Subscription;

  private lastChange: number;

  public noDisturb: boolean = false;
  public panic: boolean = false;

  @Input("section") section: string;
  @Input("icon") icon: string;
  @Input("homeVisible") homeVisible: boolean;

  constructor(
    private navCtrl: NavController,
    private nodeService: NodeService,
    private settings: Settings,
    public weather: WeatherProvider
  ) {}

  ngOnInit() {
    this.updateClock();
    this.clock$ = Observable.interval(60 * 1000).subscribe(() => {
      this.updateClock();
    });

    this.updateWeather();
    this.weather$ = Observable.interval(60 * 60 * 1000).subscribe(() => {
      this.updateWeather();
    });

    this.noDisturb = this.settings.getDisturbMode();
    this.panic = this.settings.getPanicMode();

    this.noDisturb$ = this.settings.disturbModeListener().subscribe((data) => {
      this.noDisturb = data;
    });
    this.panic$ = this.settings.panicModeListener().subscribe((data) => {
      this.panic = data;
    });
    this.block$ = this.settings.blockDevicesModeListener().subscribe((data) => {
      this.lastChange = Date.now();
      setTimeout(() => {
        if (Date.now() - this.lastChange > 1000) {
          this.nodeService.blockDevices(data).subscribe(() => {});
        }
      }, 1000);
    });
  }

  updateClock() {
    this.dateDay = moment().format("DD");
    this.dateMonth = moment().format("MMMM").substring(0, 3);
    this.dateTime = moment().format("HH:mm");
    this.dateDayName = moment().format("dddd");
  }

  updateWeather() {
    this.weather.getCoordinates().subscribe((res: any) => {
      this.weather.getWeather().subscribe((data: any) => {
        if (data) {
          if (data.main) {
            this.tempDegrees = Math.round(data.main.temp);
          }
          if (data.weather) {
            this.tempIcon = data.weather[0].icon;
          }
        }
      });
    });
  }

  goToDashboard() {
    this.navCtrl.setRoot("DashboardPage");
  }

  ngOnDestroy() {
    if (this.clock$) {
      this.clock$.unsubscribe();
    }
    if (this.weather$) {
      this.weather$.unsubscribe();
    }
    if (this.noDisturb$) {
      this.noDisturb$.unsubscribe();
    }
    if (this.panic$) {
      this.panic$.unsubscribe();
    }
    if (this.block$) {
      this.block$.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/main-header/main-header.ts